import React from "react";
import BuildProfileLayout from "../../components/BuildProfile/BuildProfileLayout";
import BuildProfileMain from "../../components/BuildProfile/BuildProfileMain";

const BuildProfileContainer = () => {
  return (
    <BuildProfileLayout>
      {/* <BildProfileTab /> */}
      <BuildProfileMain />
      {/* <BuildProfileSuccess /> */}
    </BuildProfileLayout>
  );
};

export default BuildProfileContainer;
